/**
 * TagBadges
 * Renders an array of IssueTag as Fluent UI badges
 */

import { Badge, makeStyles, mergeClasses, tokens } from '@fluentui/react-components'
import type { IssueTag } from '../domain'
import { mapTagColorToBadge } from '../utils/colorUtils'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalXS,
  },
  badge: {
    fontSize: tokens.fontSizeBase100,
    fontWeight: tokens.fontWeightMedium,
  },
})

export interface TagBadgesProps {
  tags: IssueTag[]
  size?: 'small' | 'medium' | 'large' | 'extra-large'
  className?: string
}

export function TagBadges({ tags, size = 'small', className }: TagBadgesProps) {
  const styles = useStyles()

  if (tags.length === 0) {
    return null
  }

  return (
    <div className={mergeClasses(styles.container, className)}>
      {tags.map((tag) => (
        <Badge
          key={tag.type}
          color={mapTagColorToBadge(tag.color)}
          appearance={tag.appearance === 'filled' ? 'filled' : 'tint'}
          size={size}
          className={styles.badge}
        >
          {tag.label}
        </Badge>
      ))}
    </div>
  )
}
